export default "__VITE_ASSET__g3Yy8qK6__"